import React, { Component } from 'react';
import ReactSVG from "react-svg";

class File extends Component {
    onDelete = () => this.props.handleDeleteConfirm(this.props.id);

    render() {
        const { name, loader, loading, path, id, disabled, withoutDownload } = this.props;

        return (
            <div className="file" key={id || name}>
                {/* <a href={`${path}${id}`}>{name}</a>
                {!disabled && <i className='icon icon-delete' onClick={this.onDelete} />} */}

                <a
                    className="file-preview"
                    target="_blank"
                    href={`${path}${id}&download=0`}
                    title={name}
                >
                    {name}
                </a>
                {!loading && <div className="file-actions">
                    {!withoutDownload && <a
                        className="file-download"
                        target="_blank"
                        href={`${path}${id}&download=1`}
                        title={name}
                    >
                         <ReactSVG className="svg-download" src="/data/svg/download.svg"/>
                    </a>}
                    {!disabled && <ReactSVG title={name} className="svg-delete" src="/data/svg/delete-can.svg" onClick={this.onDelete} />}
                </div>}
                {loading && loader}
            </div>
        );
    }
}

export default File;
